export const getChangesRequestedNextActorType = (request = {}) => {
  if (request?.status !== 'changes_requested') return null;

  const latestWorkflowActivity = request?.latestWorkflowActivity || null;
  if (latestWorkflowActivity?.newRequestStatus !== 'changes_requested') return null;

  return latestWorkflowActivity?.nextActorType || null;
};

export const getChangesRequestedStatusLabel = (request = {}) => {
  const nextActorType = getChangesRequestedNextActorType(request);
  if (nextActorType === 'provider') return 'Changes Requested from Provider';
  if (nextActorType === 'case_manager') return 'Changes Requested from Case Manager';
  return 'Changes Requested';
};

export const isCaseManagerReworkRound = (request = {}) =>
  getChangesRequestedNextActorType(request) === 'case_manager';

export const isProviderReworkRound = (request = {}) => {
  const nextActorType = getChangesRequestedNextActorType(request);
  if (nextActorType === 'provider') return true;
  if (nextActorType === 'case_manager') return false;

  // Preserve legacy "corrections" behavior when older rows do not yet have
  // workflow activity metadata describing who the next actor is.
  return request?.status === 'changes_requested';
};

export const isProviderOwnedRequest = (request = {}) =>
  ['sent_to_provider', 'provider_in_progress'].includes(request?.status) ||
  isProviderReworkRound(request);
